// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-136a0612] {\n  box-sizing: border-box;\n}\n.el-dropdown-link[data-v-136a0612] {\n  cursor: pointer;\n  color: #409eff;\n}\n.buttons[data-v-136a0612] {\n  margin-bottom: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
